// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__SW0hx","logo":"Navbar_logo__ZvStZ","links":"Navbar_links__HMQUC","link":"Navbar_link__AWrBc","dropdown":"Navbar_dropdown__6v-5S"};